import React from 'react';
import { Link } from 'react-router-dom';
import Block from '../../assets/Block.json';
import { toast } from 'react-toastify';
import messages from '../../assets/Messages.json';
import { getPreviousAlphabet } from '../../Custom/Custom';

export default function BlockHeader({ blockPageInfo, accessBlockIds, savedBlockIds, blockInfo }) {
  const statusUnitCode = String(localStorage.getItem('statusUnitCode') || '').trim();
  // surveyYear may be number (2024) or string ('2024') from localStorage/API
  const isSurveyYear2024 = String(blockInfo?.surveyYear ?? '') === '2024';
  const shouldSkipValidation = ['4', '5', '7', '8'].includes(statusUnitCode) && isSurveyYear2024;
  const isStatusUnitCode2 = statusUnitCode === '2';
  const isStatusUnitCode3 = statusUnitCode === '3';
  const STATUS2_SECTIONS = ['A', 'B', 'C', 'E', 'L', 'M', 'N'];
  const STATUS3_SECTIONS = ['A', 'B', 'C', 'L', 'M', 'N'];
  const STATUS4578_SECTIONS = ['A', 'B', 'L', 'M', 'N'];
  const savedIds = Array.isArray(savedBlockIds) ? savedBlockIds : accessBlockIds;

  const blockAlert = (blockName) => {
    const previewBlock = getPreviousAlphabet(blockName);

    if (['4', '5', '7', '8'].includes(statusUnitCode)) {
      toast.error('Sorry, you are not allowed to fill data in this Block', messages.COLOR_RED);
    } else if (isStatusUnitCode2) {
      toast.error('Please follow sequence A→B→C→E→L→M→N', messages.COLOR_RED);
    } else if (isStatusUnitCode3) {
      toast.error('Please follow sequence A→B→C→L→M→N', messages.COLOR_RED);
    } else {
      toast.error(`Please Save Block ${previewBlock.toUpperCase()} Data`, messages.COLOR_RED);
    }
  };

  const getAllowedSections = () => {
    if (shouldSkipValidation) return STATUS4578_SECTIONS;
    if (isStatusUnitCode3) return STATUS3_SECTIONS;
    return STATUS2_SECTIONS;
  };

  const renderBlockLink = (item, className = '') => (
    <li key={item.id} className={className}>
      <Link to={item.link}>
        <span>{item.section}</span>
        <strong>{item.title}</strong>
      </Link>
    </li>
  );

  const renderDisabledBlockLink = (item) => (
    <li key={item.id}>
      <Link to="#" onClick={() => blockAlert(item.section)}>
        <span>{item.section}</span>
        <strong>{item.title}</strong>
      </Link>
    </li>
  );

  const processBar = (item) => {
    const name = item.blockName || `${item.title}${item.section}`;
    const isActive = blockPageInfo?.blockName === name;
    const isAccessible = accessBlockIds.includes(item.id);
    const tempActive = savedIds.includes(item.id);
    const isRestrictedFlow = shouldSkipValidation || isStatusUnitCode2 || isStatusUnitCode3;
    const allowedSections = getAllowedSections();

    if (!isRestrictedFlow) {
      if (isActive) return renderBlockLink(item, 'current');
      if (isAccessible) return renderBlockLink(item, tempActive ? 'active' : '');
      return renderDisabledBlockLink(item);
    }

    const sectionAllowed = allowedSections.includes(item.section);
    if (isActive && sectionAllowed) return renderBlockLink(item, 'current');
    if (isAccessible && sectionAllowed) return renderBlockLink(item, tempActive ? 'active' : '');
    return renderDisabledBlockLink(item);
  };

  return (
    <div className="card mx-3 mb-3">
      <div className="card-body pb-1">
        <div className="row align-items-center">
          <ul id="progressbar" className="mb-3">
            {Block.map((item) => processBar(item))}
          </ul>
        </div>
      </div>
    </div>
  );
}
